import {
  getBigNumbers,
  getBuildingDetails,
  getInfoWindow,
  getMarkers,
  getTransactionsList,
  getMigratoryOrigin,
} from './realtyTransactions.infra';
import { loading, loaded } from '../../../../layout/redux/layoutActions';
import { setBigNumbers } from '../../bigNumbers/redux/bigNumbersActions';
import { generateMarkersOnMap } from './realtyTransactions.map';
import { buildCoordinates } from '../../../../shared/utils/map';
import {
  closeInfowindowTransactions,
  setInfowindowsTransactions,
  updateInputIntervals,
  updateRequestStatusT,
  updateBuildingData,
  setLaunchingYearsTransactions,
  updatePayloadChartsTransactions,
  updateChartsDataTransactions,
} from './realtyTransactions.actions';
import { AddAlert } from '../../../../component';
import {
  modalOpen,
  setDisplayCharts,
  setIsLoadingMap,
} from '../../redux/dashboardActions';
import {
  buildExistingRealties,
  buildOwnersByMontlyIncome,
  buildOwnersByAge,
  buildOwnersBySchooling,
  buildOwnersByMaritalStatus,
  buildOwnersByConsumptionPattern,
  buildPricePerSqMtMedian,
  buildTransactionedOverExistingRealties,
} from '../Factory/realtyTransactions.factory';

import infoWindowRealtyTransactions from './realtyTransactions.infowindow';
import Map from 'eemovel-map-library/src/data/google-maps/map';

let loadingStateController = {
  bigNumbers: false,
  sectors: false,
};

export const handleInputsIntervals = (e, v, tuple, typeNumber) => {
  return (dispatch) => {
    let name;
    if (!Number.isNaN(parseInt(e.value)) && parseInt(e.value) < 0) return;
    if (!e.value.match(/^(0|[1-9]\d*)+(,)?(\d{0,3})?$/) && e.value.length > 0)
      return;

    if (e.name.includes('min')) {
      tuple.min =
        typeNumber === 'int'
          ? !Number.isNaN(parseInt(e.value))
            ? parseInt(e.value)
            : ''
          : !Number.isNaN(e.value)
          ? e.value
          : '';
      name = e.name.split('min')[0];
    } else {
      name = e.name.split('max')[0];
      tuple.max =
        typeNumber === 'int'
          ? !Number.isNaN(parseInt(e.value))
            ? parseInt(e.value)
            : ''
          : !Number.isNaN(e.value)
          ? e.value
          : '';
    }

    const payload = {
      name,
      value: tuple,
    };
    dispatch(updateInputIntervals(payload));
  };
};

export const handlePriceInputs = (e, v, tuple, type) => {
  let name;
  let maskedValue = '';
  const replaceDots = e.value.replaceAll('.', '').split('R$');
  const valueAsFloat =
    replaceDots.length === 2
      ? parseInt(replaceDots[1])
      : parseInt(replaceDots[0]);
  if (!Number.isNaN(valueAsFloat)) {
    maskedValue = valueAsFloat.toLocaleString('pt-br', {
      style: 'currency',
      currency: 'BRL',
      maximumFractionDigits: 0,
    });
  }
  if (e.name.includes('min')) {
    tuple.min = maskedValue;
    name = e.name.split('min')[0];
  } else {
    tuple.max = maskedValue;
    name = e.name.split('max')[0];
  }
  const payload = {
    name,
    value: tuple,
  };
  return (dispatch) => {
    dispatch(updateInputIntervals(payload));
  };
};

const fieldsDictionary = {
  timeframemin: 'Período Inicial',
  timeframemax: 'Período Final',
  transactionPriceRangemin: 'Preço de Transação Inicial',
  transactionPriceRangemax: 'Preço de Transação Final',
  m2PriceRangemin: 'Preço do m² Inicial',
  m2PriceRangemax: 'Preço do m² Final',
  privateAreaIntervalmin: 'Área Privativa Inicial',
  privateAreaIntervalmax: 'Área Privativa Final',
  realtyAgemin: 'Idade do Imóvel Inicial',
  realtyAgemax: 'Idade do Imóvel Final',
};

export const validateForm = (formData, validation, closeModalFunc) => {
  let flag = false;
  return (dispatch) => {
    if (!formData.realtyType.id) {
      dispatch(AddAlert('warning', 'Tipo de imóvel é um campo obrigatório'));
      flag = true;
    }
    if (!Object.values(validation)?.every((el) => el === false)) {
      const removedFalses = Object.entries(validation).filter(
        (el) => el[1] !== false
      );
      const errors = removedFalses.map((el) => fieldsDictionary[el[0]]);
      const invalidFields = errors.join(', ');
      const isPlural = errors.length > 1;
      dispatch(
        AddAlert(
          'warning',
          `Campo${isPlural ? 's' : ''} inválido${
            isPlural ? 's' : ''
          }: ${invalidFields}`
        )
      );
      flag = true;
    }

    // Check and set default values for realtyAge
    if (!formData.inputIntervals.realtyAge.min) {
      formData.inputIntervals.realtyAge.min = 0;
    }
    if (!formData.inputIntervals.realtyAge.max) {
      formData.inputIntervals.realtyAge.max = 1000;
    }

    if (!flag) {
      dispatch([payloadBuilderT(formData), closeModalFunc()]);
    }
  };
};

export const generateBigNumbers = (payload) => {
  return (dispatch) => {
    dispatch(loading());
    Promise.resolve(getBigNumbers(payload))
      .then((res) => {
        const {
          existing_realties_count,
          transactioned_realties_count,
          existing_realties_median_age,
          transactioned_median_age,
        } = res.data || {
          existing_realties_count: 0,
          transactioned_realties_count: 0,
          existing_realties_median_age: 0,
          transactioned_median_age: 0,
        };
        const isZero = (value) => value === 0;

        if (
          isZero(existing_realties_count) &&
          isZero(transactioned_realties_count) &&
          isZero(existing_realties_median_age) &&
          isZero(transactioned_median_age)
        ) {
          const message = 'Não existem dados para o período selecionado.';
          dispatch(AddAlert('warning', message));
          throw new Error(message);
        }

        if (existing_realties_count)
          dispatch([
            setBigNumbers({
              existing_realties_count,
              transactioned_realties_count,
              existing_realties_median_age,
              transactioned_median_age,
            }),
            setDisplayCharts('transactions'),
          ]);
      })
      .catch((err) => console.error(err))
      .finally(() => {
        loadingStateController.bigNumbers = true;
        if (loadingStateController.sectors) {
          dispatch(loaded());
          loadingStateController.sectors = false;
          loadingStateController.bigNumbers = false;
        }
      });
  };
};

export const generateMarkers = (payload) => {
  return (dispatch) => {
    dispatch(setIsLoadingMap(true));
    Promise.resolve(getMarkers(payload))
      .then((res) => {
        dispatch(generateMarkersOnMap(res.data.pins));
      })
      .catch((err) => console.error(err))
      .finally((_) => {
        dispatch(setIsLoadingMap(false));
        loadingStateController.sectors = true;
        if (loadingStateController.bigNumbers) {
          dispatch(loaded());
          loadingStateController.sectors = false;
          loadingStateController.bigNumbers = false;
        }
      });
  };
};

export const generateCharts = (payload) => {
  return (dispatch) => {
    dispatch([
      updateRequestStatusT({
        name: 'migratoryOrigin',
        value: 'LOADING',
      }),
      loading(),
    ]);
    Promise.resolve(getMigratoryOrigin(payload))
      .then((res) => {
        const {
          proprietarios_faixa_idade,
          proprietarios_estado_civil,
          proprietarios_perfil_consumo,
          proprietarios_range_salarial,
          proprietarios_escolaridade,
          quantidade_transacoes,
          imoveis_existentes_anos,
          valor_mediano_ano,
        } = res.data;
        dispatch([
          updateChartsDataTransactions({
            owners_by_monthly_income: buildOwnersByMontlyIncome(
              proprietarios_range_salarial
            ),
            owners_by_age: buildOwnersByAge(proprietarios_faixa_idade),
            owners_by_schooling: buildOwnersBySchooling(
              proprietarios_escolaridade
            ),
            owners_by_marital_status: buildOwnersByMaritalStatus(
              proprietarios_estado_civil
            ),
            owners_by_consumption_pattern: buildOwnersByConsumptionPattern(
              proprietarios_perfil_consumo
            ),
            price_per_sq_mt_median: buildPricePerSqMtMedian(valor_mediano_ano),
            existing_realties: buildExistingRealties(imoveis_existentes_anos),
            transactioned_over_existing_realties:
              buildTransactionedOverExistingRealties(quantidade_transacoes),
          }),
          updateRequestStatusT({
            name: 'migratoryOrigin',
            value: 'LOADED',
          }),
          setDisplayCharts('transactions'),
        ]);
      })
      .catch((err) => {
        console.error(err);
        dispatch([
          updateRequestStatusT({
            name: 'migratoryOrigin',
            value: 'FAILED',
          }),
          setDisplayCharts('transactionsError'),
        ]);
      })
      .finally(() => dispatch(loaded()));
  };
};

export const generateInfoWindow = (data, marker) => {
  const payload = {
    ...data,
  };
  return (dispatch) => {
    dispatch(setIsLoadingMap(true));
    Promise.resolve(getInfoWindow(payload))
      .then((res) => {
        dispatch(closeInfowindowTransactions());
        const infowindow = infoWindowRealtyTransactions({
          payload: res.data,
          marker,
          map: Map.map,
          id: crypto.randomUUID(),
          actions: [
            {
              id: 'IWButton',
              action: () => {
                dispatch(generateBuildingDetails(payload));
              },
            },
          ],
        });
        infowindow.open();
        dispatch([setInfowindowsTransactions([infowindow.getInfowindow()])]);
      })
      .catch((err) => console.error(err))
      .finally((_) => dispatch(setIsLoadingMap(false)));
  };
};

export const generateBuildingDetails = (location_coordinates) => {
  return (dispatch) => {
    dispatch(setIsLoadingMap(true));
    Promise.resolve(getBuildingDetails(location_coordinates))
      .then((res) => {
        dispatch([
          updateBuildingData(res?.data),
          modalOpen('open building transactions'),
        ]);
      })
      .catch((err) => console.error(err))
      .finally((_) => dispatch(setIsLoadingMap(false)));
  };
};

export const generateTransactionsList = () => {
  return (dispatch) => {
    dispatch(loading());
    Promise.resolve(getTransactionsList())
      .then((res) => {
        const { years_with_transactions } = res.data;
        localStorage.setItem(
          'LaunchingYearsTransactions',
          JSON.stringify(years_with_transactions)
        );

        dispatch(setLaunchingYearsTransactions(years_with_transactions));
      })
      .catch((err) => console.error(err))
      .finally((_) => dispatch(loaded()));
  };
};

export const payloadBuilderT = (data, moreFilters) => {
  const location = buildCoordinates();
  let inputIntervals = {};
  Object.keys(data.inputIntervals).forEach((el) => {
    const val = data.inputIntervals[el];
    if (val.min !== '' && val.max !== '') {
      const validateValue = {
        min: val.min.toString(),
        max: val.max.toString(),
      };
      if (validateValue.min.includes(','))
        validateValue.min = validateValue.min.replace(',', '.');
      if (validateValue.max.includes(','))
        validateValue.max = validateValue.max.replace(',', '.');
      if (el !== 'timeframe') {
        inputIntervals = {
          ...inputIntervals,
          [el]: {
            min: Number(validateValue.min.replace(/\D/g, '')),
            max: Number(validateValue.max.replace(/\D/g, '')),
          },
        };
      } else {
        inputIntervals = {
          [el]: { min: validateValue.min, max: validateValue.max },
        };
      }
    }
  });
  data = {
    ...data,
    inputIntervals,
  };
  if (!location) {
    return (dispatch) => {
      dispatch(AddAlert('warning', 'Selecione uma área no mapa'));
    };
  } else {
    const payload = moreFilters
      ? {
          location,
          ...data,
          moreFilters,
        }
      : {
          location,
          ...data,
        };
    return (dispatch) => {
      if (payload.inputIntervals.timeframe) {
        localStorage.setItem(
          'TimeFrame',
          JSON.stringify(payload.inputIntervals.timeframe)
        );
      }
      dispatch([
        generateBigNumbers(payload),
        generateMarkers(payload),
        updatePayloadChartsTransactions(payload),
      ]);
    };
  }
};
